import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AxiosApi from "../Helper/axios.api";
import { toast } from "react-toastify";
import PageTitle from "../Components/PageTitle";
import helper from "../Helper/Helper";
import moment from "moment";
import AddSessionForm from "./Session/AddSessionForm";
import { Link, useNavigate, useParams } from "react-router-dom";
import { updateTotalCoins, logout } from "../Action/Auth.action";
import UpdateAnimation from "./UpdateAnimation";
import HoverVideoPlayer from "react-hover-video-player";

import Arrow from "../assets/images/select-arrow.svg";
import asc from "../assets/images/sort_asc.png";
import desc from "../assets/images/sort_desc.png";
import play_icon from "../assets/images/play.png";
import no_animation_icon from "../assets/images/no_animation.png";

import CreditInfo from "../Components/CreditInfo";
import CreateAnimation from "./CreateAnimation";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState("");
  const [reservation_id, setReservation_id] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [pages, setPages] = useState(0);
  const [startPage, setStartPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [createAnimationModalShow, setCreateAnimationModalShow] = useState(false);
  const [editAnimationModalShow, setEditAnimationModalShow] = useState(false);
  const [createReservationModalShow, setCreateReservationModalShow] = useState(false);
  const [notStarteModal, setNotStarteModal] = useState(false);

  const [templeteid, settempleteid] = useState("");
  const [animationData, setAnimationData] = useState([]);
  const [totalCoins, setTotalCoins] = useState("");
  const [animations, setAnimations] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [params, setParams] = useState({
    user_id: auth.userDeatils.user_id,
    search_value: "",
    field_name: "session",
    order_value: "asc",
    current_time: new Date(),
    page: 1,
    per_page: 10,
  });
  useEffect(() => {
    (async () => {
      await getAnimations();
    })();

    return () => {};
  }, [isUpdate, params.page, params.per_page]);
  useEffect(() => {
    const interval = setInterval(() => {
      (async () => {
        await getAnimations();
      })();
    }, 60000);
    return () => clearInterval(interval);
  }, [isUpdate, params.page, params.per_page]);
  useEffect(() => {
    setTotalCoins(auth.total_coin);
  }, [auth.total_coin]);

  const getAnimations = async (e) => {
    await AxiosApi.withToken(auth.accessToken, "templates", "post", params)
      .then(async (res) => {
        if (res.status) {
          setAnimations([...res.data.live_templates, ...res.data.template]);
          if (res.data.total_coin) {
            setTotalCoins(res.data.total_coin);
          }
          dispatch(updateTotalCoins(res.data));
          setTotalRows(res.data.pagination.total);
          getPager(
            res.data.pagination.total,
            res.data.pagination.current_page,
            params.per_page,
            res.data.pagination.last_pages
          );
        } else {
          toast.error(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });

          if (res.login === false) {
            dispatch(logout());
            navigate("/login", { replace: true });
          }
        }
        setLoading(false);
      })
      .catch((errors_res) => {
        setLoading(false);
      });
  };
  function getPager(totalItems, currentPage, pageSize, last_pages) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || 10;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    // create an array of pages to ng-repeat in the pager control
    var pages = [...Array(last_pages + 1 - startPage).keys()].map(
      (i) => startPage + i
    );

    setPages(pages);
    setTotalPages(totalPages);
  }
  const setPagenumber = (page) => {
    setParams({
      ...params,
      page,
    });
  };
  //This is for search
  const onParamChange = (e) => {
    let value = e.target.value;
    setParams({
      ...params,
      [e.target.name]: value,
    });
    setIsUpdate(!isUpdate);
  };
  const requestSort = (key) => {
    let direction = "asc";
    if (params && params.field_name === key && params.order_value === "asc") {
      direction = "desc";
    }
    setParams({
      ...params,
      field_name: key,
      order_value: direction,
    });

    setIsUpdate(!isUpdate);
  };
  const getClassNamesFor = (name) => {
    if (!params) {
      return Arrow;
    }
    if (params.field_name === name) {
      if (params.order_value == "asc") {
        return asc;
      } else {
        return desc;
      }
    } else {
      return Arrow;
    }
  };
  const createPreviews = async (template_id) => {
    await AxiosApi.withToken(
      auth.accessToken,
      "templates/create_preview",
      "post",
      {template_id: template_id, user_id: auth.userDeatils.user_id},
    );
    await getAnimations();
  }
  const showCreateReservationModal = (row) => {
    setAnimationData(row);
    settempleteid(row.id);
    setCreateReservationModalShow(true);
  };
  const showEditReservationModal = (session, animation) => {
    setAnimationData(animation);
    settempleteid(session.template_id);
    setReservation_id(session.id);
    setIsUpdate(true);
    setCreateReservationModalShow(true);
  };

  function diffYMDHMS(date1, date2, fortime) {
    var string_data = "";
    let years = date1.diff(date2, "year");
    date2.add(years, "years");

    let months = date1.diff(date2, "months");
    date2.add(months, "months");

    let days = date1.diff(date2, "days");
    date2.add(days, "days");

    let hours = date1.diff(date2, "hours");
    date2.add(hours, "hours");

    let minutes = date1.diff(date2, "minutes");
    date2.add(minutes, "minutes");

    let seconds = date1.diff(date2, "seconds");

    if (years > 0) {
      if (fortime) {
        return date1.local().format("MMM DD,YYYY h:mm A");
      } else {
        return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
      }
    }
    if (months > 0) {
      if (fortime) {
        return date1.local().format("MMM DD,YYYY h:mm A");
      } else {
        return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
      }
    }

    if (days > 0) {
      if (days == 1) {
        if (fortime) {
          return (
            "<b>Tomorrow</b> at <b>" + date1.local().format("h:mm A") + "</b>"
          );
        } else {
          return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
        }
      } else {
        if (fortime) {
          return date1.local().format("MMM DD,YYYY h:mm A");
        } else {
          return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
        }
      }
    }

    if (hours > 0) {
      string_data += " " + hours + "h";
    }
    if (minutes > 0) {
      string_data += " " + minutes + "m";
    }
    if (seconds > 0) {
      string_data += " " + seconds + "s";
    }
    if (fortime) {
      return "<b>Start</b> in <b>" + string_data + "</b>";
    } else {
      return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
    }
  }

  const get_session_schedule = (session_data, fortime) => {
    var date2 = new Date();
    let current_time = moment(date2).format("yyyy-MM-DD HH:mm");
    let start_time = moment(session_data.time_start).format("yyyy-MM-DD HH:mm");
    let result = moment(current_time).isBefore(start_time); // true
    if (result) {
      var now = moment(new Date());
      var end = moment(session_data.time_start);
      let diff = diffYMDHMS(end, now, fortime);
      return diff;
    } else {
      if (fortime) {
        return "<b>Session is in Progress..</b>";
      } else {
        return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Open deeptherapy session <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
      }
    }
  };

  const show_modal = async (event_id) => {
    navigate("/reservation/" + event_id);
  };

  const update_reservations = async () => {
    setCreateReservationModalShow(true);
  };

  return (
    <>
      <PageTitle title="DeepTherapy | Animations" />
      <div className="virtualization">
        <div className="card w-100">
          <div id={loading ? "pageLoader" : ""} />
          <div className="card-header bg-white d-flex align-items-center justify-content-between">
            <div className="card-header-left">
              <div className="card-header-top d-flex align-items-center mb-2">
                <div className="card-title">My Animations</div>
                <div className="credit-remaining-text px-3">
                  <strong>{totalCoins ? totalCoins : ""}</strong>{" "}
                  <span className="text-gray">credits remaining</span>
                </div>
                <CreditInfo />
                <div className="more-credits-col ps-3">
                  <Link to={"/subscription"}>Get more credits</Link>
                </div>
                <div className="more-credits-col ps-3">
                  <a href="https://3duniversum.notion.site/Information-for-Therapists-1f8df0fe8aa480639f92eb8bd3f28197" target="_blank">
                    How to use DeepTherapy (EN)
                  </a>
                  {" "}/{" "}
                  <a href="https://3duniversum.notion.site/Informatie-voor-therapeuten-1f8df0fe8aa480e99a83fa317ca55660" target="_blank">
                    (NL)
                  </a>
                </div>
              </div>
            </div>
            <div className="card-header-right">
              <div className="search-col pe-3">
                <div className="input-group">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fa fa-search"></i>
                  </span>
                  <input
                    type="text"
                    name="search_value"
                    id="search_value"
                    className="form-control"
                    placeholder="Search animations..."
                    onChange={(e) => onParamChange(e)}
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-primary btn-createanimation"
                onClick={() => setCreateAnimationModalShow(true)}
              >
                + Create Animation
              </button>
            </div>
          </div>
          <div className="card-body">
            {/* Mobile Sort Controls - only visible on mobile */}
            <div className="mobile-sort-controls mobile-only" style={{ width: '100%', maxWidth: '100%' }}>
              <button
                type="button"
                className={`btn btn-sort ${params.field_name === 'name' ? 'active' : ''}`}
                onClick={() => requestSort("name")}
                title="Sort by name"
              >
                Name <img src={getClassNamesFor("name")} alt="Sort" />
              </button>
              <button
                type="button"
                className={`btn btn-sort ${params.field_name === 'created_at' ? 'active' : ''}`}
                onClick={() => requestSort("created_at")}
                title="Sort by date"
              >
                Date <img src={getClassNamesFor("created_at")} alt="Sort" />
              </button>
            </div>            <div className="animations-container" style={{ width: '100%', maxWidth: '100%' }}>
              {/* Desktop Table Header */}
              <div className="animation-thead desktop-only d-flex">
                <div className="animation-th animation-col d-flex align-items-center justify-content-between w-10">
                  Animation
                </div>
                <div
                  className="animation-th title-col d-flex align-items-center justify-content-between w-30"
                  onClick={() => requestSort("name")}
                >
                  Title
                  <img src={getClassNamesFor("name")} alt="Arrow" />
                </div>
                <div
                  className="animation-th date-col d-flex align-items-center justify-content-between w-25"
                  onClick={() => requestSort("created_at")}
                >
                  Creation Date
                  <img src={getClassNamesFor("created_at")} alt="Arrow" />
                </div>
                <div className="animation-th features-col d-flex align-items-center justify-content-between w-20">
                  Features
                </div>
                <div className="animation-th status-col w-15">
                  <div className="w-100 d-flex actions-gap">
                    Actions
                  </div>
                </div>
              </div>
            <div className="animation-tbody">
              {animations.length > 0 ? (
                animations.map((row, index) => (
                  <div
                    key={index}
                    className={`animation-tr ${
                      row.live ? 'live-animation' : 'normal-animation'
                    }`}
                    style={{ width: '100%', maxWidth: '100%' }}
                  >
                    {/* Mobile Card Layout */}
                    <div className="mobile-card mobile-only" style={{ width: '100%', maxWidth: '100%' }}>
                      <div className="mobile-card-header">
                        <div className="animation-preview">
                          {row.video !== '' ? (
                            <HoverVideoPlayer
                              className="hover-video-player"
                              videoSrc={`${helper.ApiBaseUrl}${row.video}`}
                              restartOnPaused
                              loadingOverlay={
                                <div className="loading-overlay">
                                  <div className="loading-spinner" />
                                </div>
                              }
                              pausedOverlay={
                                <img
                                  src={play_icon}
                                  alt="mouseover to play video"
                                  className="video-play-overlay"
                                />
                              }
                            />
                          ): (
                            <img
                              src={`${helper.ApiBaseUrl}${row.thumb}`}
                              className="animation-thumb"
                              alt="Animation thumbnail"
                            />
                          )}
                        </div>
                        <div className="animation-info">
                          <h3 className="animation-name">
                            {row.name ? row.name : ""}
                          </h3>
                          <div className="animation-date">
                            {row.created_at
                              ? moment(row.created_at).format("MMM D, YYYY")
                              : ""}
                          </div>
                        </div>
                      </div>

                      <div className="mobile-card-features">
                        <span className="badge badge-video-animation">
                          <i className="fa fa-video"></i>
                          Video Animation
                        </span>

                        {row.enable_morphing && (
                          <span
                            className={`badge premium-ai-badge badge-ai-voice ${!row.voice_self_chosen ? 'default-ai-voice' : ''}`}
                            title={!row.voice_self_chosen ? 'Default AI Voice - Click Edit to customize' : 'Custom AI Voice'}
                          >
                            <i className="fa fa-microphone"></i>
                            {!row.voice_self_chosen ? 'Default AI Voice' : 'AI Voice'}
                            <i className="fa fa-crown"></i>
                            {!row.voice_self_chosen && (
                              <i className="fa fa-exclamation-circle default-voice-indicator"></i>
                            )}
                          </span>
                        )}
                      </div>

                      <div className="mobile-card-actions">
                        <button
                          type="button"
                          className={`btn btn-primary animation-action-button ${row.enable_morphing && !row.voice_self_chosen ? 'needs-voice-edit' : ''}`}
                          style={{ flex: '1', marginRight: '0.5rem' }}
                          onClick={(e) => {
                            settempleteid(row.id);
                            setEditAnimationModalShow(true);
                          }}
                          title={row.enable_morphing && !row.voice_self_chosen ? "Edit Animation - Customize AI Voice" : "Edit Animation"}
                        >
                          <i className="fa fa-edit"></i>
                          <span>Edit</span>
                        </button>
                        {(() => {
                          if (row.session) {
                            let string_data = get_session_schedule(row.session, false);
                            if (string_data.includes("Open")) {
                              return (
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    flex: '1',
                                    backgroundColor: '#28a745',
                                    borderColor: '#28a745',
                                    color: 'white',
                                    padding: '0.375rem 0.75rem',
                                    fontSize: '0.875rem',
                                    lineHeight: '1.5',
                                    borderRadius: '0.25rem',
                                    border: '1px solid #28a745'
                                  }}
                                  onClick={(e) => show_modal(row.session.id)}
                                  title="Open deeptherapy session"
                                >
                                  <i className="fa fa-play me-2" aria-hidden="true"></i>
                                  <span>Open Session</span>
                                </button>
                              );
                            } else {
                              return (
                                <button
                                  type="button"
                                  className="btn btn-primary animation-action-button"
                                  style={{ flex: '1' }}
                                  onClick={() => {
                                    setAnimationData(row);
                                    settempleteid(row.id);
                                    setReservation_id(row.session.id);
                                    setCreateReservationModalShow(true);
                                  }}
                                  title="Update Schedule"
                                >
                                  <i className="fa fa-calendar-edit" aria-hidden="true"></i>
                                  <span>Update Schedule</span>
                                </button>
                              );
                            }
                          } else {
                            return (
                              <button
                                type="button"
                                className="btn btn-primary animation-action-button"
                                style={{ flex: '1' }}
                                onClick={(e) => showCreateReservationModal(row)}
                                title="Schedule Animation"
                              >
                                <i className="fa fa-calendar-plus" aria-hidden="true"></i>
                                <span>Schedule</span>
                              </button>
                            );
                          }
                        })()}
                      </div>

                      {row.live && (
                        <div className="live-progress-indicator">
                          <p className="live-progress-text">
                            <span className="animate-flicker live-progress-dot" />
                            <span className="live-progress-spacer" />
                            IN PROGRESS
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Desktop Table Layout */}
                    <div className="desktop-row desktop-only d-flex align-items-center">
                      <div className="animation-td animation-col w-10 d-flex">
                        {row.video !== '' ? (
                          <HoverVideoPlayer
                            className="hover-video-player"
                            videoSrc={`${helper.ApiBaseUrl}${row.video}`}
                            restartOnPaused
                            loadingOverlay={
                              <div className="loading-overlay">
                                <div className="loading-spinner" />
                              </div>
                            }
                            pausedOverlay={
                              <img
                                src={play_icon}
                                alt="mouseover to play video"
                                className="video-play-overlay"
                              />
                            }
                          />
                        ): (
                          <img
                            src={`${helper.ApiBaseUrl}${row.thumb}`}
                            className="animation-thumb"
                            alt="Animation thumbnail"
                          />
                        )}
                      </div>
                      <div className="animation-td title-col w-30">
                        <p className="animation-name h1">
                          {row.name ? row.name : ""}
                        </p>
                      </div>
                      <div className="animation-td date-col w-25">
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                          <span style={{ textAlign: 'center', fontWeight: 500, fontSize: '1rem', color: '#222', minWidth: '120px' }}>
                            {row.created_at
                              ? moment(row.created_at).format("MMM D, YYYY hh:mm A")
                              : ""}
                          </span>
                        </div>
                      </div>
                      <div className="animation-td features-col w-20">
                        <div className="features-badges pe-5">
                          <span className="badge badge-video-animation">
                            <i className="fa fa-video"></i>
                            Video Animation
                          </span>

                          {(row.enable_morphing) && (
                            <span
                              className={`badge premium-ai-badge badge-ai-voice ${!row.voice_self_chosen ? 'default-ai-voice' : ''}`}
                              title={!row.voice_self_chosen ? 'Default AI Voice - Click Edit to customize' : 'Custom AI Voice'}
                            >
                              <i className="fa fa-microphone"></i>
                              {!row.voice_self_chosen ? 'Default AI Voice' : 'AI Voice'}
                              <i className="fa fa-crown"></i>
                              {!row.voice_self_chosen && (
                                <i className="fa fa-exclamation-circle default-voice-indicator"></i>
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="animation-td status-col w-15">
                        <div className="w-100 d-flex justify-content-start">
                          <button
                            type="button"
                            className={`btn btn-primary animation-action-button me-2 ${row.enable_morphing && !row.voice_self_chosen ? 'needs-voice-edit' : ''}`}
                            onClick={(e) => {
                              settempleteid(row.id);
                              setEditAnimationModalShow(true);
                            }}
                            title={row.enable_morphing && !row.voice_self_chosen ? "Edit Animation - Customize AI Voice" : "Edit Animation"}
                          >
                            <i className="fa fa-edit"></i>edit
                          </button>
                          {(() => {
                            if (row.session) {
                              let string_data = get_session_schedule(row.session, false);
                              if (string_data.includes("Open")) {
                                return (
                                  <button
                                    type="button"
                                    className="btn"
                                    style={{
                                      backgroundColor: '#28a745',
                                      borderColor: '#28a745',
                                      color: 'white',
                                      padding: '0.375rem 0.75rem',
                                      fontSize: '0.875rem',
                                      lineHeight: '1.5',
                                      borderRadius: '0.25rem',
                                      border: '1px solid #28a745'
                                    }}
                                    onClick={(e) => show_modal(row.session.id)}
                                    title="Open deeptherapy session"
                                  >
                                    <i className="fa fa-play me-1" aria-hidden="true"></i>
                                    open session
                                  </button>
                                );
                              } else {
                                return (
                                  <button
                                    type="button"
                                    className="btn btn-primary animation-action-button"
                                    onClick={() => {
                                      setAnimationData(row);
                                      settempleteid(row.id);
                                      setReservation_id(row.session.id);
                                      setCreateReservationModalShow(true);
                                    }}
                                    title="Update Schedule"
                                  >
                                    <i className="fa fa-calendar-edit" aria-hidden="true"></i>
                                    update schedule
                                  </button>
                                );
                              }
                            } else {
                              return (
                                <button
                                  type="button"
                                  className="btn btn-primary animation-action-button"
                                  onClick={(e) => showCreateReservationModal(row)}
                                  title={"Schedule Animation"}
                                >
                                  <i
                                    className="fa fa-calendar-plus"
                                    aria-hidden="true"
                                  ></i>
                                  schedule
                                </button>
                              );
                            }
                          })()}
                        </div>
                      </div>

                      {row.live && (
                        <div className="live-progress-indicator">
                          <p className="live-progress-text">
                            <span className="animate-flicker live-progress-dot" />
                            <span className="live-progress-spacer" />
                            IN PROGRESS
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="animation-tr d-flex align-items-center" style={{ width: '100%', maxWidth: '100%' }}>
                  <div className="animation-td animation-col w-100">
                    <div className="middle_section">
                      <img src={no_animation_icon} alt="No Animation" />
                      <p>No Animations Created Yet</p>
                      <span>Click “Create Animation” to get started!</span>
                    </div>
                  </div>
                </div>
              )}
              <div className="pagination-row">
                {totalRows <= params.per_page ? null : (
                  <div className="pagination justify-content-center">
                    <ul className="pagination pagination-top-spacing">
                      <li
                        className={
                          params.page === 1 ? "page-item disabled" : "page-item"
                        }
                      >
                        <a
                          className="page-link"
                          onClick={() => setPagenumber(1)}
                        >
                          <i
                            className="fa fa-fast-backward"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                      <li
                        className={
                          params.page === 1 ? "page-item disabled" : "page-item"
                        }
                      >
                        <a
                          className="page-link"
                          onClick={() => setPagenumber(params.page - 1)}
                        >
                          <i
                            className="fa fa-chevron-left"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                      {pages.length > 0
                        ? pages.map((page, index) => (
                            <li
                              key={index}
                              role="button"
                              className={
                                params.page === page
                                  ? "page-item active"
                                  : "page-item"
                              }
                            >
                              <a
                                className="page-link"
                                onClick={() => setPagenumber(page)}
                              >
                                {page}
                              </a>
                            </li>
                          ))
                        : ""}
                      <li
                        className={
                          params.page === totalPages
                            ? "page-item disabled"
                            : "page-item"
                        }
                      >
                        <a
                          className="page-link"
                          onClick={() => setPagenumber(params.page + 1)}
                        >
                          <i
                            className="fa fa-chevron-right"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                      <li
                        className={
                          params.page === totalPages
                            ? "page-item disabled"
                            : "page-item"
                        }
                      >
                        <a
                          className="page-link"
                          onClick={() => setPagenumber(totalPages)}
                        >
                          <i
                            className="fa fa-fast-forward"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <CreateAnimation
        modalShow={createAnimationModalShow}
        setModalShow={setCreateAnimationModalShow}
        setIsUpdate={setIsUpdate}
        isUpdate={isUpdate}
      />
      <UpdateAnimation
        modal={editAnimationModalShow}
        setModal={setEditAnimationModalShow}
        setIsUpdate={setIsUpdate}
        isUpdate={isUpdate}
        templeteid={templeteid}
        settempleteid={settempleteid}
        createschedule={showCreateReservationModal}
        openschedule={showEditReservationModal}
        createPreviews={createPreviews}
      />
      <AddSessionForm
        modal={createReservationModalShow}
        setModal={setCreateReservationModalShow}
        reservation_id={reservation_id}
        setReservation_id={setReservation_id}
        animationData={animationData}
        formType={"virtualizationForm"}
        templeteid={templeteid}
        settempleteid={settempleteid}
        isUpdate={isUpdate}
        setIsUpdate={setIsUpdate}
      />
    </>
  );
}
